<template>
  <div class="bordered-group vs-card vs-con-block mt-5">
    <div class="vs-card-content">
      <div class="vx-row ">
        <div class="vx-col w-full">
          <vs-table max-items="10" :data="paymentExpenses">
            <template slot="header">
              <div class="vx-row  w-full mb-1 mr-0 ml-0 p-0">
                <div class="vx-col w-1/3">
                  <h6>ข้อมูลการชำระเงิน (ค่าใช้จ่าย)</h6>
                </div>
                <div class="vx-col w-2/3 flex justify-end m-0 p-0">
                  <AdminPaymentQr expense-only />
                  <vs-button color="success" type="filled" icon-pack="feather" icon="icon-plus"
                             @click="onPressedActiveAddPaymentExpense()">เพิ่มข้อมูล
                  </vs-button>
                </div>
              </div>
            </template>

            <template slot="thead">
              <vs-th>#</vs-th>
              <vs-th>วันที่ชำระ</vs-th>
              <vs-th>ประเภทการชำระ</vs-th>
              <vs-th>จำนวน</vs-th>
              <vs-th class="col-createdBy">ผู้บันทึก</vs-th>
              <vs-th class="col-approved">สถานะ</vs-th>
              <vs-th class="col-actions"></vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="row" :key="index" v-for="(row, index) in data">
                <vs-td>{{ data.length - index }}</vs-td>
                <vs-td>{{ row.paymentDateLocalTh }}</vs-td>
                <vs-td>
                  {{ row.paymentTypeName }}
                </vs-td>
                <vs-td class="text-right">{{ row.paymentAmount | numberFormat }}</vs-td>
                <vs-td>{{ row.createByFullName }}<br>{{ row.createdAtLocalTh }}</vs-td>
                <vs-td>
                  <QrReceiptProcess v-if="row.qrPayment || row.paymentType === IPaymentType.qrCode" :qr="row.qrPayment" :payment-expense-id="row.id" :approved-status="row.approvedStatus" />
                  <vs-chip v-else-if="row.approvedStatus === IApprovedStatus.draft" color="warning">รอประมวลผล</vs-chip>
                  <vs-chip v-else-if="row.approvedStatus === IApprovedStatus.approved" color="success">ประมวลผลแล้ว</vs-chip>
                  <vs-chip v-else-if="row.approvedStatus === IApprovedStatus.cancel" color="danger">ยกเลิก</vs-chip>
                </vs-td>
                <vs-td>
                  <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end" v-if="!row.qrPayment && row.paymentType !== IPaymentType.qrCode">
                    <vx-tooltip text="ยืนยันข้อมูล">
                      <vs-button class="mr-1" color="success" type="filled" icon-pack="feather" icon="icon-check"
                                 @click="onPressedApprovedPaymentExpense(row.id)"
                                 v-if="row.approvedStatus === IApprovedStatus.draft"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip text="แก้ไขข้อมูล">
                      <vs-button class="mr-1" color="warning" type="filled" icon-pack="feather" icon="icon-edit"
                                 @click="onPressedActiveUpdatePaymentExpense(row)"
                                 v-if="row.approvedStatus === IApprovedStatus.draft"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip text="ยกเลิกข้อมูล">
                      <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-x-circle"
                                 @click="onPressedCanceledPaymentExpense(row.id)"
                                 v-if="row.approvedStatus === IApprovedStatus.approved && isRoot"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip text="ลบข้อมูล">
                      <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash"
                                 @click="onPressedDelPaymentExpense(row.id)"
                                 v-if="row.approvedStatus === IApprovedStatus.draft"></vs-button>
                    </vx-tooltip>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>

    </div>

    <vs-popup
      :active.sync="paymentExpenseModal.active"
      :title="paymentExpenseModal.title"
      class="custom-popup"
    >
      <div class="popup-content">
        <ValidationObserver v-slot="{ handleSubmit }" ref="form">
          <form @submit.prevent="handleSubmit">
            <div class="vx-row">
              <div class="vx-col w-1/2">
                <ValidationProvider name="วันที่" rules="required" v-slot="{ errors }">
                  <label class="text-sm">วันที่*</label>
                  <flat-pickr :config="configDatePaymentExpense" class="w-full" v-model="paymentExpenseModal.date"/>
                  <span class="text-danger text-sm" v-show="errors[0]">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col w-1/2">
                <ValidationProvider name="ปรับยอด" rules="" v-slot="{ errors }">
                  <label class="text-sm">ปรับยอด</label>
                  <vs-checkbox v-model="paymentExpenseModal.adjustment"></vs-checkbox>
                  <span class="text-danger text-sm" v-show="errors[0]">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-1/2">
                <ValidationProvider :name="$t('getters.expenseTypesOptions')['ContractFee']" :rules="{ required: true }"
                                    v-slot="{ errors }">
                  <label class="text-sm">{{ $t('getters.expenseTypesOptions')['ContractFee'] }}</label>
                  <vs-input type="number" class="w-full" v-model="paymentExpenseModal.paymentContractFee"/>
                  <span class="text-danger text-sm" v-show="errors[0]">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col w-1/2">
                <ValidationProvider :name="$t('getters.expenseTypesOptions')['TaxAmount']" :rules="{ required: true }"
                                    v-slot="{ errors }">
                  <label class="text-sm">{{ $t('getters.expenseTypesOptions')['TaxAmount'] }}</label>
                  <vs-input type="number" class="w-full" v-model="paymentExpenseModal.paymentTaxAmount"/>
                  <span class="text-danger text-sm" v-show="errors[0]">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-1/2">
                <ValidationProvider :name="$t('getters.expenseTypesOptions')['ProcessingFee']"
                                    :rules="{ required: true }" v-slot="{ errors }">
                  <label class="text-sm">{{ $t('getters.expenseTypesOptions')['ProcessingFee'] }}</label>
                  <vs-input type="number" class="w-full" v-model="paymentExpenseModal.paymentProcessingFee"/>
                  <span class="text-danger text-sm" v-show="errors[0]">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col w-1/2">
                <ValidationProvider :name="$t('getters.expenseTypesOptions')['CourtOrderExpense']"
                                    :rules="{ required: true }" v-slot="{ errors }">
                  <label class="text-sm">{{ $t('getters.expenseTypesOptions')['CourtOrderExpense'] }}</label>
                  <vs-input type="number" class="w-full" v-model="paymentExpenseModal.paymentCourtOrderExpense"/>
                  <span class="text-danger text-sm" v-show="errors[0]">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-1/2">
                <ValidationProvider name="ยอดรวมการชำระ" :rules="{ required: true, min_value: 0.01 }"
                                    v-slot="{ errors }">
                  <label class="text-sm">ยอดรวมการชำระ</label>
                  <vs-input type="number" class="w-full" v-model="calculatedPaymentAmount" readonly="readonly"/>
                  <span class="text-danger text-sm" v-show="errors[0]">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col w-full">
                <validation-provider name="หมายเหตุ" rules="required" v-slot="{ errors }">
                  <label class="vs-input--label">หมายเหตุ*</label>
                  <vs-textarea v-model="paymentExpenseModal.paymentRemark" rows="5"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
      <div class="popup-footer">
        <vs-button color="success" @click="onPressedAcceptAddPaymentExpense">บันทึก</vs-button>
        <vs-button color="danger" @click="paymentExpenseModal.active = false">ยกเลิก</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import QrReceiptProcess from "@/components/QrReceiptProcess.vue";
import Divider from "@/views/components/vuesax/divider/Divider.vue";
import {createNamespacedHelpers} from "vuex";
import moment from "moment";
import AdminPaymentQr from "../AdminPaymentQr.vue";
import {Thai} from 'flatpickr/dist/l10n/th'
import 'flatpickr/dist/themes/dark.css';
import flatPickr from "vue-flatpickr-component";
import {IApprovedStatus, IPaymentType} from "@/constants/interface";
import {isRoot as fncIsRoot} from "@/utils";

const {mapActions: mapAccountingActions, mapState: mapAccountingFields} = createNamespacedHelpers('Accounting');

export default {
  name: 'PaymentExpenseInfoTab',
  components: {
    QrReceiptProcess,
    AdminPaymentQr,
    Divider,
    flatPickr
  },
  data() {
    return {
      clearTransactionsPopup: {
        active: false,
        date: moment().format('DD-MM-YYYY'),
      },
      paymentExpenseModal: {
        active: false,
        type: 'add',
        title: 'เพิ่มข้อมูลการชำระเงิน (ค่าใช้จ่าย)',
        id: null,
        date: moment().format('DD-MM-YYYY'),
        paymentContractFee: 0,
        paymentTaxAmount: 0,
        paymentProcessingFee: 0,
        paymentCourtOrderExpense: 0,
        adjustment: false,
        paymentRemark: "",
      },
    };
  },
  computed: {
    ...mapAccountingFields(['contractDetail', 'contractDetailPaymentExpenses']),
    IApprovedStatus() {
      return IApprovedStatus
    },
    IPaymentType() {
      return IPaymentType
    },
    isRoot() {
      return fncIsRoot();
    },
    calculatedPaymentAmount() {
      return (
        Number(this.paymentExpenseModal.paymentContractFee || 0) +
        Number(this.paymentExpenseModal.paymentTaxAmount || 0) +
        Number(this.paymentExpenseModal.paymentProcessingFee || 0) +
        Number(this.paymentExpenseModal.paymentCourtOrderExpense || 0)
      );
    },
    configDatePaymentExpense() {
      let minDate = null
      let maxDate = null

      return {
        monthSelectorType: "static",
        allowInput: true,
        locale: Thai,
        dateFormat: "d-m-Y",
        minDate,
        maxDate
      }
    },
    paymentExpenses() {
      if (!this.contractDetailPaymentExpenses) return null;
      return [...this.contractDetailPaymentExpenses]
        .sort(({paymentDate: aPaymentDate, createdAt: aCreatedAt}, {
          paymentDate: bPaymentDate,
          createdAt: bCreatedAt
        }) => {
          const paymentDateDiff = new Date(bPaymentDate) - new Date(aPaymentDate);
          if (paymentDateDiff !== 0) {
            return paymentDateDiff;
          }
          return new Date(bCreatedAt) - new Date(aCreatedAt);
        })
        .map((payment) => {
          const {
            id,
            paymentType,

            qrPayment,
            adjustment,
            receiveDate,
            paymentDate,
            paymentAmount,
            paymentContractFee,
            paymentTaxAmount,
            paymentProcessingFee,
            paymentCourtOrderExpense,
            paymentRemark,
            approvedStatus,
            createdAt,
            // extra fields
            paymentTypeName,
            paymentDateLocalTh,
            createdAtLocalTh,
            createByFullName,
          } = payment;
          return {
            id,
            paymentType,

            qrPayment,
            adjustment,
            receiveDate,
            paymentDate,
            paymentAmount,
            paymentContractFee,
            paymentTaxAmount,
            paymentProcessingFee,
            paymentCourtOrderExpense,
            paymentRemark,
            approvedStatus,
            createdAt,
            // extra fields
            paymentTypeName,
            paymentDateLocalTh,
            createdAtLocalTh,
            createByFullName,
          }
        })
    },
  },
  methods: {
    ...mapAccountingActions(['getContractDetail', 'approvedContractDetailPaymentExpense', 'createContractDetailPaymentExpense', 'updateContractDetailPaymentExpense', 'deleteContractDetailPaymentExpense', 'canceledContractDetailPaymentExpense']),
    async onPressedActiveAddPaymentExpense() {
      const vm = this
      vm.paymentExpenseModal.active = true
      vm.paymentExpenseModal.type = 'add'
      vm.paymentExpenseModal.id = null
      vm.paymentExpenseModal.title = 'เพิ่มข้อมูลการชำระเงิน (ค่าใช้จ่าย)'
      vm.paymentExpenseModal.date = moment().format('DD-MM-YYYY');
      vm.paymentExpenseModal.adjustment = false
      vm.paymentExpenseModal.paymentContractFee = 0
      vm.paymentExpenseModal.paymentTaxAmount = 0
      vm.paymentExpenseModal.paymentProcessingFee = 0
      vm.paymentExpenseModal.paymentCourtOrderExpense = 0
      vm.paymentExpenseModal.paymentRemark = ""
    },
    async onPressedApprovedPaymentExpense(id) {
      const vm = this
      const contractId = vm.$route.params.id;
      const {approvedContractDetailPaymentExpense, getContractDetail} = vm;
      vm.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'ยืนยันข้อมูล',
        text: 'คุณต้องการยืนยันข้อมูลใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await approvedContractDetailPaymentExpense({
            id,
            vm
          })
          await getContractDetail({
            id: contractId
          })
        }
      })
    },
    async onPressedCanceledPaymentExpense(id) {
      const vm = this
      const contractId = vm.$route.params.id;
      const {canceledContractDetailPaymentExpense, getContractDetail} = vm;
      vm.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'ยืนยันการยกเลิกข้อมูล',
        text: 'คุณต้องการยกเลิกข้อมูลใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await canceledContractDetailPaymentExpense({
            id,
            vm
          })
          await getContractDetail({
            id: contractId
          })
        }
      })
    },
    async onPressedActiveUpdatePaymentExpense(row) {
      const vm = this
      vm.paymentExpenseModal.active = true
      vm.paymentExpenseModal.type = 'update'
      vm.paymentExpenseModal.id = row.id
      vm.paymentExpenseModal.title = 'แก้ไขข้อมูลการชำระเงิน (ค่าใช้จ่าย)'
      vm.paymentExpenseModal.date = moment(row.paymentDate).format('DD-MM-YYYY');
      vm.paymentExpenseModal.adjustment = row.adjustment
      vm.paymentExpenseModal.paymentContractFee = row.paymentContractFee
      vm.paymentExpenseModal.paymentTaxAmount = row.paymentTaxAmount
      vm.paymentExpenseModal.paymentProcessingFee = row.paymentProcessingFee
      vm.paymentExpenseModal.paymentCourtOrderExpense = row.paymentCourtOrderExpense
      vm.paymentExpenseModal.paymentRemark = row.paymentRemark
    },
    async onPressedAcceptAddPaymentExpense() {
      const vm = this
      const contractId = this.$route.params.id;
      const {createContractDetailPaymentExpense, updateContractDetailPaymentExpense} = vm;
      vm.$refs['form'].validate().then(async success => {
        if (!success) {
          return
        }
        const receiveDate = vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.paymentExpenseModal.date.trim())
        const paymentDate = vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.paymentExpenseModal.date.trim())
        if (vm.paymentExpenseModal.type === 'add') {
          await createContractDetailPaymentExpense({
            contractId,
            form: {
              receiveDate: receiveDate,
              paymentDate: paymentDate,
              adjustment: vm.paymentExpenseModal.adjustment,
              paymentAmount: parseFloat(vm.calculatedPaymentAmount),
              paymentContractFee: parseFloat(vm.paymentExpenseModal.paymentContractFee),
              paymentTaxAmount: parseFloat(vm.paymentExpenseModal.paymentTaxAmount),
              paymentProcessingFee: parseFloat(vm.paymentExpenseModal.paymentProcessingFee),
              paymentCourtOrderExpense: parseFloat(vm.paymentExpenseModal.paymentCourtOrderExpense),
              paymentRemark: vm.paymentExpenseModal.paymentRemark,
            }
          });
        } else if (vm.paymentExpenseModal.type === 'update') {
          await updateContractDetailPaymentExpense({
            id: vm.paymentExpenseModal.id,
            form: {
              receiveDate: receiveDate,
              paymentDate: paymentDate,
              adjustment: vm.paymentExpenseModal.adjustment,
              paymentAmount: parseFloat(vm.calculatedPaymentAmount),
              paymentContractFee: parseFloat(vm.paymentExpenseModal.paymentContractFee),
              paymentTaxAmount: parseFloat(vm.paymentExpenseModal.paymentTaxAmount),
              paymentProcessingFee: parseFloat(vm.paymentExpenseModal.paymentProcessingFee),
              paymentCourtOrderExpense: parseFloat(vm.paymentExpenseModal.paymentCourtOrderExpense),
              paymentRemark: vm.paymentExpenseModal.paymentRemark,
            }
          })
        }
        vm.paymentExpenseModal.active = false;
      })
    },
    async onPressedDelPaymentExpense(id) {
      const vm = this
      const {deleteContractDetailPaymentExpense} = vm;
      vm.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'ยืนยันการลบข้อมูล',
        text: 'คุณต้องการลบข้อมูลใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await deleteContractDetailPaymentExpense({
            id,
            vm
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.vx-row {
  margin-bottom: 15px;
}

.col-createdBy {
  width: 200px;
}

.col-approved {
  width: 130px;
}

.col-actions {
  width: 100px;
}

.custom-popup .vs-popup {
  width: 600px;
}

.popup-content {
  padding: 10px;
}

.popup-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  border-top: 1px solid #e0e0e0;
}

.popup-footer .vs-button + .vs-button {
  margin-left: 10px;
}
</style>
